/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum Country {
    Austria = 'Austria',
    Germany = 'Germany',
    Croatia = 'Croatia',
    Slovenia = 'Slovenia',
    Albania = 'Albania',
    Andorra = 'Andorra',
    Belarus = 'Belarus',
    Belgium = 'Belgium',
    BosniaAndHerzegovina = 'BosniaAndHerzegovina',
    Bulgaria = 'Bulgaria',
    Cyprus = 'Cyprus',
    CzechRepublic = 'CzechRepublic',
    Denmark = 'Denmark',
    Estonia = 'Estonia',
    Finland = 'Finland',
    France = 'France',
    Greece = 'Greece',
    Hungary = 'Hungary',
    Iceland = 'Iceland',
    Ireland = 'Ireland',
    Italy = 'Italy',
    Kosovo = 'Kosovo',
    Latvia = 'Latvia',
    Liechtenstein = 'Liechtenstein',
    Lithuania = 'Lithuania',
    Luxembourg = 'Luxembourg',
    Malta = 'Malta',
    Moldova = 'Moldova',
    Monaco = 'Monaco',
    Montenegro = 'Montenegro',
    Netherlands = 'Netherlands',
    NorthMacedonia = 'NorthMacedonia',
    Norway = 'Norway',
    Poland = 'Poland',
    Portugal = 'Portugal',
    Romania = 'Romania',
    Russia = 'Russia',
    SanMarino = 'SanMarino',
    Serbia = 'Serbia',
    Slovakia = 'Slovakia',
    Spain = 'Spain',
    Sweden = 'Sweden',
    Switzerland = 'Switzerland',
    Turkey = 'Turkey',
    Ukraine = 'Ukraine',
    UnitedKingdom = 'UnitedKingdom',
    VaticanCity = 'VaticanCity'
  }

    export const CountryTranslocoMap: Record<Country, string> = {
    [Country.Austria]: 'country.austria',
    [Country.Germany]: 'country.germany',
    [Country.Croatia]: 'country.croatia',
    [Country.Slovenia]: 'country.slovenia',
    [Country.Albania]: 'country.albania',
    [Country.Andorra]: 'country.andorra',
    [Country.Belarus]: 'country.belarus',
    [Country.Belgium]: 'country.belgium',
    [Country.BosniaAndHerzegovina]: 'country.bosniaAndHerzegovina',
    [Country.Bulgaria]: 'country.bulgaria',
    [Country.Cyprus]: 'country.cyprus',
    [Country.CzechRepublic]: 'country.czechRepublic',
    [Country.Denmark]: 'country.denmark',
    [Country.Estonia]: 'country.estonia',
    [Country.Finland]: 'country.finland',
    [Country.France]: 'country.france',
    [Country.Greece]: 'country.greece',
    [Country.Hungary]: 'country.hungary',
    [Country.Iceland]: 'country.iceland',
    [Country.Ireland]: 'country.ireland',
    [Country.Italy]: 'country.italy',
    [Country.Kosovo]: 'country.kosovo',
    [Country.Latvia]: 'country.latvia',
    [Country.Liechtenstein]: 'country.liechtenstein',
    [Country.Lithuania]: 'country.lithuania',
    [Country.Luxembourg]: 'country.luxembourg',
    [Country.Malta]: 'country.malta',
    [Country.Moldova]: 'country.moldova',
    [Country.Monaco]: 'country.monaco',
    [Country.Montenegro]: 'country.montenegro',
    [Country.Netherlands]: 'country.netherlands',
    [Country.NorthMacedonia]: 'country.northMacedonia',
    [Country.Norway]: 'country.norway',
    [Country.Poland]: 'country.poland',
    [Country.Portugal]: 'country.portugal',
    [Country.Romania]: 'country.romania',
    [Country.Russia]: 'country.russia',
    [Country.SanMarino]: 'country.sanMarino',
    [Country.Serbia]: 'country.serbia',
    [Country.Slovakia]: 'country.slovakia',
    [Country.Spain]: 'country.spain',
    [Country.Sweden]: 'country.sweden',
    [Country.Switzerland]: 'country.switzerland',
    [Country.Turkey]: 'country.turkey',
    [Country.Ukraine]: 'country.ukraine',
    [Country.UnitedKingdom]: 'country.unitedKingdom',
    [Country.VaticanCity]: 'country.vaticanCity',
    };

    export const CountryOptions = [
  { value: Country.Austria, labelKey: 'country.austria' },
  { value: Country.Germany, labelKey: 'country.germany' },
  { value: Country.Croatia, labelKey: 'country.croatia' },
  { value: Country.Slovenia, labelKey: 'country.slovenia' },
  { value: Country.Albania, labelKey: 'country.albania' },
  { value: Country.Andorra, labelKey: 'country.andorra' },
  { value: Country.Belarus, labelKey: 'country.belarus' },
  { value: Country.Belgium, labelKey: 'country.belgium' },
  { value: Country.BosniaAndHerzegovina, labelKey: 'country.bosniaAndHerzegovina' },
  { value: Country.Bulgaria, labelKey: 'country.bulgaria' },
  { value: Country.Cyprus, labelKey: 'country.cyprus' },
  { value: Country.CzechRepublic, labelKey: 'country.czechRepublic' },
  { value: Country.Denmark, labelKey: 'country.denmark' },
  { value: Country.Estonia, labelKey: 'country.estonia' },
  { value: Country.Finland, labelKey: 'country.finland' },
  { value: Country.France, labelKey: 'country.france' },
  { value: Country.Greece, labelKey: 'country.greece' },
  { value: Country.Hungary, labelKey: 'country.hungary' },
  { value: Country.Iceland, labelKey: 'country.iceland' },
  { value: Country.Ireland, labelKey: 'country.ireland' },
  { value: Country.Italy, labelKey: 'country.italy' },
  { value: Country.Kosovo, labelKey: 'country.kosovo' },
  { value: Country.Latvia, labelKey: 'country.latvia' },
  { value: Country.Liechtenstein, labelKey: 'country.liechtenstein' },
  { value: Country.Lithuania, labelKey: 'country.lithuania' },
  { value: Country.Luxembourg, labelKey: 'country.luxembourg' },
  { value: Country.Malta, labelKey: 'country.malta' },
  { value: Country.Moldova, labelKey: 'country.moldova' },
  { value: Country.Monaco, labelKey: 'country.monaco' },
  { value: Country.Montenegro, labelKey: 'country.montenegro' },
  { value: Country.Netherlands, labelKey: 'country.netherlands' },
  { value: Country.NorthMacedonia, labelKey: 'country.northMacedonia' },
  { value: Country.Norway, labelKey: 'country.norway' },
  { value: Country.Poland, labelKey: 'country.poland' },
  { value: Country.Portugal, labelKey: 'country.portugal' },
  { value: Country.Romania, labelKey: 'country.romania' },
  { value: Country.Russia, labelKey: 'country.russia' },
  { value: Country.SanMarino, labelKey: 'country.sanMarino' },
  { value: Country.Serbia, labelKey: 'country.serbia' },
  { value: Country.Slovakia, labelKey: 'country.slovakia' },
  { value: Country.Spain, labelKey: 'country.spain' },
  { value: Country.Sweden, labelKey: 'country.sweden' },
  { value: Country.Switzerland, labelKey: 'country.switzerland' },
  { value: Country.Turkey, labelKey: 'country.turkey' },
  { value: Country.Ukraine, labelKey: 'country.ukraine' },
  { value: Country.UnitedKingdom, labelKey: 'country.unitedKingdom' },
  { value: Country.VaticanCity, labelKey: 'country.vaticanCity' },
    ];

